module.exports = __webpack_public_path__ + "static/icon-about-97e31653e6c77aba660d099edf441d22.png";